import { analyticsUtils } from 'utils/analytics-utils';
import { useEffectOnce } from './use-effect-once';

export type PageViewProps = {
  userId: string | null;
  userAuth: 1 | 0;
};

/**
 * Отправка GA:pageview события при первом рендере страницы
 * @param {'Landing' | 'ServicePage'} pageType        - тип страницы
 * @param {string | undefined | null} pagePath        - URL страницы
 * @param {PageViewProps | undefined} [pageViewProps] - Доп. параметры для отправки события "GA:pageview"
 */
export const usePageViewEvent = (
  pagePath: string | undefined | null,
  pageType: 'Landing' | 'ServicePage' | undefined,
  pageViewProps?: PageViewProps
) => {
  useEffectOnce(() => {
    if (pagePath) {
      analyticsUtils.sendEvent('GA:pageview', {
        pageType,
        pagePath,
        ...pageViewProps,
      });
    }
  });
};
